"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _default = {
    v: "5.5.7",
    meta: {
        g: "LottieFiles AE 0.1.21",
        a: "",
        k: "",
        d: "",
        tc: ""
    },
    fr: 60,
    ip: 0,
    op: 124,
    w: 500,
    h: 500,
    nm: "Spinner MultiComps",
    ddd: 0,
    assets: [
        {
            id: "comp_0",
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: "Spinner",
                    parent: 2,
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    d: 1,
                                    ty: "el",
                                    s: {
                                        a: 0,
                                        k: [
                                            253.867,
                                            253.867
                                        ],
                                        ix: 2
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 3
                                    },
                                    nm: "Ellipse Path 1",
                                    mn: "ADBE Vector Shape - Ellipse",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.822150707245,
                                            0.720268130302,
                                            0.022379931062,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 26,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 1,
                                    ml: 4,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Ellipse 1",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.667
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            50
                                        ]
                                    },
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.333
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 22,
                                        s: [
                                            30
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            50
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.667
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            51
                                        ]
                                    },
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.333
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 22,
                                        s: [
                                            65
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            51
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            180
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            540
                                        ]
                                    }
                                ],
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 60,
                    st: 0,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 3,
                    nm: "White Solid 1",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    ip: 0,
                    op: 60,
                    st: 0,
                    bm: 0
                }
            ]
        },
        {
            id: "comp_1",
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: "Spinner",
                    parent: 2,
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    d: 1,
                                    ty: "el",
                                    s: {
                                        a: 0,
                                        k: [
                                            253.867,
                                            253.867
                                        ],
                                        ix: 2
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 3
                                    },
                                    nm: "Ellipse Path 1",
                                    mn: "ADBE Vector Shape - Ellipse",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 0,
                                        k: [
                                            0.852190554142,
                                            0.09724213928,
                                            0.532586574554,
                                            1
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 26,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 1,
                                    ml: 4,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Ellipse 1",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.667
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            50
                                        ]
                                    },
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.333
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 22,
                                        s: [
                                            30
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            50
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.667
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            51
                                        ]
                                    },
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.333
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 22,
                                        s: [
                                            65
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            51
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            180
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            540
                                        ]
                                    }
                                ],
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 60,
                    st: 0,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 3,
                    nm: "White Solid 1",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    ip: 0,
                    op: 60,
                    st: 0,
                    bm: 0
                }
            ]
        },
        {
            id: "comp_2",
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: "Spinner",
                    parent: 2,
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: "gr",
                            it: [
                                {
                                    d: 1,
                                    ty: "el",
                                    s: {
                                        a: 0,
                                        k: [
                                            253.867,
                                            253.867
                                        ],
                                        ix: 2
                                    },
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 3
                                    },
                                    nm: "Ellipse Path 1",
                                    mn: "ADBE Vector Shape - Ellipse",
                                    hd: false
                                },
                                {
                                    ty: "st",
                                    c: {
                                        a: 1,
                                        k: [
                                            {
                                                i: {
                                                    x: [
                                                        0.833
                                                    ],
                                                    y: [
                                                        0.833
                                                    ]
                                                },
                                                o: {
                                                    x: [
                                                        0.167
                                                    ],
                                                    y: [
                                                        0.167
                                                    ]
                                                },
                                                t: 0,
                                                s: [
                                                    0.155944854021,
                                                    0.09724213928,
                                                    0.852190554142,
                                                    1
                                                ]
                                            },
                                            {
                                                t: 40,
                                                s: [
                                                    0.09724213928,
                                                    0.789393782616,
                                                    0.852190554142,
                                                    1
                                                ]
                                            }
                                        ],
                                        ix: 3
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 4
                                    },
                                    w: {
                                        a: 0,
                                        k: 26,
                                        ix: 5
                                    },
                                    lc: 2,
                                    lj: 1,
                                    ml: 4,
                                    bm: 0,
                                    nm: "Stroke 1",
                                    mn: "ADBE Vector Graphic - Stroke",
                                    hd: false
                                },
                                {
                                    ty: "tr",
                                    p: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 2
                                    },
                                    a: {
                                        a: 0,
                                        k: [
                                            0,
                                            0
                                        ],
                                        ix: 1
                                    },
                                    s: {
                                        a: 0,
                                        k: [
                                            100,
                                            100
                                        ],
                                        ix: 3
                                    },
                                    r: {
                                        a: 0,
                                        k: 0,
                                        ix: 6
                                    },
                                    o: {
                                        a: 0,
                                        k: 100,
                                        ix: 7
                                    },
                                    sk: {
                                        a: 0,
                                        k: 0,
                                        ix: 4
                                    },
                                    sa: {
                                        a: 0,
                                        k: 0,
                                        ix: 5
                                    },
                                    nm: "Transform"
                                }
                            ],
                            nm: "Ellipse 1",
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: "ADBE Vector Group",
                            hd: false
                        },
                        {
                            ty: "tm",
                            s: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.667
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            50
                                        ]
                                    },
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.333
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 22,
                                        s: [
                                            30
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            50
                                        ]
                                    }
                                ],
                                ix: 1
                            },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.667
                                            ],
                                            y: [
                                                1
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            51
                                        ]
                                    },
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.333
                                            ],
                                            y: [
                                                0
                                            ]
                                        },
                                        t: 22,
                                        s: [
                                            65
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            51
                                        ]
                                    }
                                ],
                                ix: 2
                            },
                            o: {
                                a: 1,
                                k: [
                                    {
                                        i: {
                                            x: [
                                                0.833
                                            ],
                                            y: [
                                                0.833
                                            ]
                                        },
                                        o: {
                                            x: [
                                                0.167
                                            ],
                                            y: [
                                                0.167
                                            ]
                                        },
                                        t: 0,
                                        s: [
                                            180
                                        ]
                                    },
                                    {
                                        t: 39,
                                        s: [
                                            540
                                        ]
                                    }
                                ],
                                ix: 3
                            },
                            m: 1,
                            ix: 2,
                            nm: "Trim Paths 1",
                            mn: "ADBE Vector Filter - Trim",
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 60,
                    st: 0,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 3,
                    nm: "White Solid 1",
                    sr: 1,
                    ks: {
                        o: {
                            a: 0,
                            k: 100,
                            ix: 11
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 10
                        },
                        p: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                250,
                                250,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100,
                                100
                            ],
                            ix: 6
                        }
                    },
                    ao: 0,
                    ip: 0,
                    op: 60,
                    st: 0,
                    bm: 0
                }
            ]
        }
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 0,
            nm: "Spinner Yellow",
            refId: "comp_0",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        250,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        250,
                        250,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            w: 500,
            h: 500,
            ip: 82,
            op: 123,
            st: 82,
            bm: 0
        },
        {
            ddd: 0,
            ind: 2,
            ty: 0,
            nm: "Spinner Pink",
            refId: "comp_1",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        250,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        250,
                        250,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            w: 500,
            h: 500,
            ip: 41,
            op: 82,
            st: 41,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 0,
            nm: "Spinner Blue",
            refId: "comp_2",
            sr: 1,
            ks: {
                o: {
                    a: 0,
                    k: 100,
                    ix: 11
                },
                r: {
                    a: 0,
                    k: 0,
                    ix: 10
                },
                p: {
                    a: 0,
                    k: [
                        250,
                        250,
                        0
                    ],
                    ix: 2
                },
                a: {
                    a: 0,
                    k: [
                        250,
                        250,
                        0
                    ],
                    ix: 1
                },
                s: {
                    a: 0,
                    k: [
                        100,
                        100,
                        100
                    ],
                    ix: 6
                }
            },
            ao: 0,
            w: 500,
            h: 500,
            ip: 0,
            op: 41,
            st: 0,
            bm: 0
        }
    ],
    markers: []
};

//# sourceMappingURL=loadingThreeColor.js.map